import { Capacitor } from '@capacitor/core'
import { MaybeRef } from '@vueuse/core'
import { DataRow } from '../types/components/data-rendering'
import { computed, ref, unref } from 'vue'

/** Hook to get defaults for different tables */
export const useFilteringDisplayOptions = (options?: {
  isFetching?: MaybeRef<boolean>
  showAllChecks?: MaybeRef<boolean>
}) => {
  const isNative = computed(() => Capacitor.isNativePlatform())
  const taskListDisplayOptions = computed(() => {
    return {
      checks:
        unref(options?.showAllChecks) || isNative.value
          ? {
              // eslint-disable-next-line
              checklist: (row: DataRow) => {
                return true
              },
              checkProps: {
                disable: options && options.isFetching ? unref(options.isFetching) : false,
              },
            }
          : undefined,
      route: { link: (row: DataRow) => `/tasks/${row.task_id}` },
    }
  })

  const pickListDisplayOptions = computed(() => {
    return {
      checks: {
        checklist: () => true,
        checkProps: {
          disable: false,
        },
      },
      // cellOptions: {
      //   cellClass: cellClassByKey('text-primary underline cursor-pointer', 'artwork_id'),
      //   atCellClick: (key: keyof DataRow, row: DataRow) => {
      //     if (key === 'artwork_id') {
      //       openOrderModal.value = true
      //       pickListClickedRow.value = row
      //     }
      //   },
      // },
    }
  })

  const openOrderModal = ref(false)
  const pickListClickedRow = ref()

  const merchPlannerDisplayOptions = computed(() => {
    return {
      cellOptions: {
        cellClass: cellClassByKey('text-primary underline', 'recap'),
        atCellClick: (key: keyof DataRow, row: DataRow) => {
          if (key === 'recap') {
            //Action for recap preview will go here
            row
          }
        },
      },
    }
  })
  return {
    //task index
    taskListDisplayOptions,
    //Picklist
    pickListDisplayOptions,
    openOrderModal,
    pickListClickedRow,
    //merch planner
    merchPlannerDisplayOptions,
  }
}

/*
 * Helpers
 */
/**
 * Takes a class name and col name to build out a function that will be mapped to table cells.
 * @param className Class name to apply to the cell
 * @param colName Column name to which class name will be applied
 * @returns Function that applies class name if key is the same as column name
 */
const cellClassByKey = (className: string, colName: string) => (key: keyof DataRow) => {
  if (key === colName) {
    return className
  } else {
    return ''
  }
}
